import React from 'react';
import { Modal, Table, Form, Empty, Input, Button, Tag, Checkbox } from 'antd';

const REGISTRADO = 1;
const EMITIDO = 2;
const RECHAZADO = 3;
const ANULADO = 4;


export default class FormModalImportarComprobante extends React.Component {
    render() {
        const renderColor = (row) => {
            if (row.idComprobanteEstado === REGISTRADO)
                return 'blue';
            if (row.idComprobanteEstado === EMITIDO)
                return 'green';
            if (row.idComprobanteEstado === RECHAZADO)
                return 'orange';
            if (row.idComprobanteEstado === ANULADO)
                return 'red';
        };
        return (
            
        <Modal
            title={"Búsqueda de comprobantes"}
            visible={this.props.visible}
            style={{ top: 30 }}
            width="1150px"
            onCancel={this.props.onCancel}
            onOk={this.props.onHandleOkImportarComprobante}
        >
            <Form>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <Form.Item label="">

                        </Form.Item>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Table
                            
                            size="small"
                            style={{ overflowX: 'auto' }}
                            rowClassName='cursor-pointer'
                            rowKey={record => record.id}
                            dataSource={this.props.formValues.dataSource}
                            onRow={
                                (item) => ({ onClick: () => (this.props.onChangeRow(item)) })
                            }
                            locale={{
                                emptyText: <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description="No se encontraron datos."
                                />
                            }}
                            columns={[
                                {
                                    title: 'Serie',
                                    dataIndex: 'serie',
                                    key: 'serie',
                                    sorter: true
                                },
                                {
                                    title: 'Documento',
                                    dataIndex: 'documento',
                                    key: 'documento',
                                    sorter: true
                                },
                                {
                                    title: 'Fecha',
                                    dataIndex: 'fechaStr',
                                    key: 'fechaStr',
                                    sorter: true
                                },
                                {
                                    title: 'Tipo Documento',
                                    dataIndex: 'tipoDocumentoCliente',
                                    key: 'tipoDocumentoCliente',
                                    sorter: true
                                },
                                {
                                    title: 'Número Documento',
                                    dataIndex: 'numeroDocumentoCliente',
                                    key: 'numeroDocumentoCliente',
                                    sorter: true
                                },
                                // {
                                //     title: 'Cliente',
                                //     dataIndex: 'razonSocialCliente',
                                //     key: 'razonSocialCliente',
                                //     sorter: true,
                                //     render: (value) => (
                                //         <div style={{ minWidth: "150px" }}>{value}</div>
                                //     )
                                // },
                                {
                                    title: 'Moneda',
                                    dataIndex: 'moneda',
                                    key: 'moneda',
                                    sorter: true
                                },
                                {
                                    title: 'Sub Total',
                                    dataIndex: 'subTotal',
                                    key: 'subTotal',
                                    align: 'right',
                                    sorter: true,
                                    render: (value) => (
                                        <span>{value.toFixed(2)}</span>
                                    )
                                },
                                {
                                    title: 'Igv',
                                    dataIndex: 'igv',
                                    key: 'igv',
                                    align: 'right',
                                    sorter: true,
                                    render: (value) => (
                                        <span>{value.toFixed(2)}</span>
                                    )
                                },
                                {
                                    title: 'Total',
                                    dataIndex: 'total',
                                    key: 'total',
                                    align: 'right',
                                    sorter: true,
                                    render: (data) => (
                                        <span>{data.toFixed(2)}</span>
                                    )
                                },
                                {
                                    title: 'Estado',
                                    dataIndex: 'nombreComprobanteEstado',
                                    key: 'nombreComprobanteEstado',
                                    align: 'center',
                                    width: "90px",
                                    fixed: 'right',
                                    render: (value, row) => {
                                        return (<div className="custom-options" >
                                            <Tag color={renderColor(row)}>{value}</Tag>
                                        </div>)
                                    }
                                }
                            ]}
                        />
                    </div>
                </div>

                <br/>

                <div className="row">
                    <div className="col-md-12">
                    <Table
                            size="small"
                            style={{ overflowX: 'auto' }}
                            rowClassName='cursor-pointer'
                            rowKey={record => record.id}
                            dataSource={this.props.formValues.dataSourceDetalle}
                            locale={{
                                emptyText: <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description="No se encontraron datos."
                                />
                            }}
                            columns={[
                                {
                                    title: 'Codigo',
                                    dataIndex: 'codigoReferencia',
                                    key: 'codigoReferencia',
                                    sorter: true
                                },
                                {
                                    title: 'Nombre',
                                    dataIndex: 'nombre',
                                    key: 'nombre',
                                    sorter: true
                                },
                                {
                                    title: 'Unidad Medida',
                                    dataIndex: 'nombreUnidadMedida',
                                    key: 'nombreUnidadMedida',
                                    sorter: true
                                },
                                {
                                    title: 'Lote',
                                    dataIndex: 'numeroLote',
                                    key: 'numeroLote',
                                    sorter: true
                                },
                                {
                                    title: 'Cantidad',
                                    dataIndex: 'cantidad',
                                    key: 'cantidad',
                                    align: 'right',
                                    sorter: true
                                },
                                {
                                    title: 'Precio Unitario',
                                    dataIndex: 'precioUnitario',
                                    key: 'precioUnitario',
                                    align: 'right',
                                    sorter: true,
                                    render: (value) => (
                                        <span>{value.toFixed(2)}</span>
                                    )
                                },
                                {
                                    title: 'Afecto',
                                    dataIndex: 'flagAfecto',
                                    key: 'flagAfecto',
                                    align: 'center',
                                    render: (value) => (
                                        <Checkbox checked={value}></Checkbox>
                                    )
                                },
                                {
                                    title: 'Igv',
                                    dataIndex: 'igv',
                                    key: 'igv',
                                    align: 'right',
                                    sorter: true,
                                    render: (value) => (
                                        <span>{value.toFixed(2)}</span>
                                    )
                                },
                                {
                                    title: 'Sub Total',
                                    dataIndex: 'subTotal',
                                    key: 'subTotal',
                                    align: 'right',
                                    sorter: true,
                                    render: (data) => (
                                        <span>{data.toFixed(2)}</span>
                                    )
                                },
                                {
                                    title: 'Total',
                                    dataIndex: 'total',
                                    key: 'total',
                                    align: 'right',
                                    sorter: true,
                                    render: (data) => (
                                        <span>{data.toFixed(2)}</span>
                                    )
                                }
                            ]}
                        />
                    </div>
                </div>
            </Form>
        </Modal>
        )
    }
}
